/* eslint-disable no-template-curly-in-string */

import { TClient } from '@frontend/applications/PaymentsApp/types';
import { TProject } from '../../types';

export const getDefaultProductEmailTemplate = (program?: TProject, client?: TClient) => {
  const programTitle = program?.title || 'Program';
  const clientName = client?.name || 'Client';

  return {
    title: `Product Email Template for ${programTitle}`,
    subject: `${clientName} | Terms for ${programTitle}`,
    text: JSON.stringify({
    blocks: [
      {
        key: 'fe0b3',
        text: 'Hi First Name,',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 3,
            length: 10,
            key: 0,
          },
        ],
        data: {

        },
      },
      {
        key: '9h4f2',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'dmm5t',
        text: 'Congratulations on the brief acceptance! As per the next step, please',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '83g1o',
        text: 'submit your Product Order Selection:',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '9gdat',
        text: 'Link to Terms',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 0,
            length: 13,
            key: 1,
          },
        ],
        data: {

        },
      },
      {
        key: '4u785',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'acdan',
        text: 'In order for us to send you our products, we need you to submit your',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '7j25j',
        text: 'selection to get the process started!',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '5fa88',
        text: '',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '37h2h',
        text: 'Please let us know if you have any questions or concerns.',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: '9k85p',
        text: 'Best,',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [

        ],
        data: {

        },
      },
      {
        key: 'qt96m',
        text: 'User Name',
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [

        ],
        entityRanges: [
          {
            offset: 0,
            length: 9,
            key: 2,
          },
        ],
        data: {

        },
      },
    ],
    entityMap: {
      0: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'MEMBER_FIELDS.${id}',
          },
        },
      },
      1: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'LINK_TO_TERMS',
          },
        },
      },
      2: {
        type: 'variable',
        mutability: 'IMMUTABLE',
        data: {
          data: {
            field: 'USER_NAME',
            },
          },
        },
      },
    }),
  };
};
